// extracted by mini-css-extract-plugin
export default {"productGrid":"yZ-z","centerLink":"zZ-z","productSection":"AZ-z","item":"BZ-z","ctaButton":"CZ-z"};